import Vue from 'vue'
import axios from 'axios'
const axiosIns = axios.create({
  // baseURL: `/api`,
  // baseURL: `http://${window.location.hostname}:9091/api`,
  baseURL: `https://${window.location.hostname}/api`,
})

//
// axiosIns.interceptors.response.use( response =>  response ,
//    error =>  {
//

// //     if (error.response.status === 419) {
// //         var path = window.location.pathname;
// //         var page = path.split("/").pop();
// //         cookie.deleteAllCookies()
// //         // console.log( 'page',page );
// //         if (page !== "login") {
// //             window.location = '/login';
// //         }
// //
// //
// //     }
// //     // if (400 === error.response.status || 403 ===  error.response.status) {
// //     //     var path = window.location.pathname;
// //     //     var page = path.split("/").pop();
// //     //     cookie.deleteAllCookies()
// //     //     if (page !== "login") {
// //     //         window.location = '/login';
// //     //     }
// //     // }
// //
// //     return Promise.reject(error);
// });

axiosIns.defaults.withCredentials = true;

Vue.prototype.$axios = axiosIns

export default axiosIns
